import { TimeLabel } from 'bz-core-controls';
import DateLabelHooks from 'bz-core-controls/controls/general/date/date-label-hooks';
import Drawing from 'bz-core-controls/controls/general/signature-control/drawing';
import HooksForm from 'bz-core-controls/hooks-form';
import FormSignature from 'bz-core-controls/hooks-form/controls/signature';
import React from 'react';
import { ChangeSignatureRequest } from 'tm3-core/api.dtos';

interface IProps {
  signature: string;
  signedAt: string | undefined;
  signedBy: string | undefined;
}

const ViewSignature: React.FC<IProps> = ({ signature, signedAt, signedBy }) => {
  const hasBase64Img = React.useMemo(() => signature && signature.includes('base64'), [signature]);
  const validatorKey = React.useMemo(() => new ChangeSignatureRequest(), []);
  return (
    <div>
      <hr className="m-5 mb-2" />
      <div className="flex items-center justify-center">
        <div>
          {hasBase64Img ? (
            <img
              className="max-h-[200px] max-w-[200px]"
              src={signature}
              alt={`Signed by ${signedBy} at ${signedAt}`}
            />
          ) : (
            <HooksForm validatorKey={validatorKey}>
              <FormSignature name="signature" disabled={true} defaultValue={signature} />
            </HooksForm>
          )}
          <div className="flex items-center justify-center">
            <div className="text-xs">
              {signedBy && <p>Signed by {signedBy}</p>}
              {signedAt && (
                <>
                  Signed: <DateLabelHooks value={signedAt} /> <TimeLabel value={signedAt} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSignature;
